import React, { SetStateAction, useEffect, useState } from "react";
import { Actor } from "../types/xapi";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "../../../../store/store";

const useActor = (): [Actor, React.Dispatch<SetStateAction<Actor>>] => {
  const { id, email } = useAppSelector((state) => state.UserInfoSlice.profile);
  const { pathname } = useLocation();

  const [actor, setActor] = useState<Actor>({
    objectType: "user",
    extension: {
      source: pathname,
      sourceType: "muse"
    },
    id,
    mbox: `mailto:${email}`
  });

  return [actor, setActor];
};

export default useActor;
